import { render } from "./SingleCelebration.vue?vue&type=template&id=f6c3c182"
import script from "./SingleCelebration.vue?vue&type=script&lang=js"
export * from "./SingleCelebration.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__